import React from 'react';
import { MenuItem } from '@mui/material';
import { SalesOrderFiltersState } from './types';

/**
 * Helper para crear opciones de menú con una opción "Todos" por defecto
 */
export const createMenuItems = <T extends { id: string | number; name: string }>(
	items: T[],
	getValue: (item: T) => string = (item) => item.id.toString(),
): React.ReactElement[] => [
	<MenuItem key="todos" value="">
		<em>Todos</em>
	</MenuItem>,
	...items.map((item) => (
		<MenuItem key={item.id} value={getValue(item)}>
			{item.name}
		</MenuItem>
	)),
];

/**
 * Obtiene el valor por defecto para un campo de filtro al limpiarlo
 */
export const getDefaultFilterValue = (
	field: keyof SalesOrderFiltersState,
): SalesOrderFiltersState[keyof SalesOrderFiltersState] => {
	// Campos booleanos que usan null como valor por defecto
	const nullableBooleanFields: (keyof SalesOrderFiltersState)[] = [
		'hasPendingPayAmount',
		'customerEmpty',
		'isBitrixDeal',
		'isReturnDateReached',
	];

	if (nullableBooleanFields.includes(field)) {
		return null;
	}

	// Campos de preset (string vacío)
	if (field.includes('Preset')) {
		return '';
	}

	// Campos de fecha (null)
	if (field.includes('Date')) {
		return null;
	}

	// Campos específicos con valores por defecto personalizados
	const specificDefaults: Partial<Record<keyof SalesOrderFiltersState, any>> = {
		servicesTypes: [],
		invoicingStatuses: [],
		onlyMine: false,
		createdBy: '',
	};

	if (field in specificDefaults) {
		return specificDefaults[field];
	}

	// Valor por defecto genérico (string vacío)
	return '';
};
